import testUsers from 'configs/testUser.json';
import { resolveFromToken } from 'utils/resolveFromToken';

export function isInternalUser(): boolean {
  return resolveFromToken('email')?.split('@')[1] === 'trendyol.com';
}

export function isTestUser(): boolean {
  return testUsers.users.includes(resolveFromToken('email') ?? '');
}
